import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const usersPsychologistsSelector = (state: RootState) => state.usersPsychologists;
